<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_0">
<p class="calibre7"><span id="pgepubid00035" title="[Pg 34]"></span></p>
<h2 class="nobreak" id="CHAPTER_V">CHAPTER V<br class="calibre16"/><br class="calibre16"/>
<span class="small">THE LUCKNOW ROAD</span></h2>
</div>
<p class="calibre7">"<span class="smcap">And</span> now for a good spin along the Lucknow
road," said Gascoigne when they had extricated
themselves from the teeming bazaar.</p>
<p class="calibre7">Oh, Lucknow road! How many times have you
resounded to the steady tramp of armed men, the
clattering of hoofs, the rumble of guns! What battles
have been fought to guard you, what nameless
graves of gallant fellows are scattered among the
crops in your vicinity! But to-night all is peace; the
moon rides high in the heavens, and the whole landscape
seems flooded in silvery white. The pace at
which Sally travelled created a current of fresh air,
as she sped past tombs, shrines, villages, and between
long avenues of trees. The bare, flat plains were
just forty miles from the foot of the Himalayas, and
in the cold weather the scene presented an unbroken
stretch of rich cultivation. A sea of yellow waves,
wheat and barley, sugar-cane, feathery white cotton,
and acres and acres of poppies. Now the crops were
gathered, and all that remained was a barren expanse
parched to a dull dusty brown. The very trees,
with their grey trunks and leafless branches, gave
the scene a bleak and wintry appearance, although
the air was like a furnace. It was a still,
breathless night, save for the croaking of frogs, or
the humming of a village tom-tom, and the couple

<span id="pgepubid00036" title="[Pg 35]"></span>

in the dogcart were as silent as their surroundings,
absorbing the swiftly changing scene without exchanging
a word, each being buried in their own
reflections. Angel's thoughts were pleasant ones;
her busy brain was occupied with visions of future
triumphs—not unconnected with her present position,
and her new hat.</p>
<p class="calibre7">Gascoigne's inner self was far, far away across
the sea. He was driving with a little girl through
deep country lanes, a girl then his playfellow, later
his divinity, now lost to him, and figuratively laid in
a grave and wrapped in roses and lavender. On the
tombstone the strong god Circumstance had inscribed,
"Here lies the love of Philip Gascoigne."
The man was thinking of his love, the child of her
new hat, and the four-legged animal of her supper.
Once or twice he had been on the point of turning,
but a piteous little voice beside him had pleaded,
"Oh, please, not yet; oh, just another mile, well,
half-a-mile," and they had passed the tenth milestone
before Sally was pulled up and her head set
once more towards Ramghur.</p>
<p class="calibre7">"Oh, dear," cried Angel, coming out of a dream,
"I'm so sorry we are going back. I began to think
I was in heaven."</p>
<p class="calibre7">"Upon my word, you are a funny child," exclaimed
her cousin. "I don't fancy the hot weather
in the North-West is many people's notion of Paradise."</p>
<p class="calibre7">"But there are horses and chariots there. At all
events," she argued, "the Bible says so."</p>
<p class="calibre7">"Do you read the Bible much, Angel?"</p>
<p class="calibre7">"Yes. I love the Book of Revelations, which tells

<span id="pgepubid00037" title="[Pg 36]"></span>

all about gold and jewels and horses. I always read
it on Sundays."</p>
<p class="calibre7">"And what do you read on week-days?"</p>
<p class="calibre7">"I have not much time. I sew a good deal for
mother, and there are lessons, and going out walking
with those children to the club gardens twice a
day," and she gave a little impatient sigh. Gascoigne
looked down at the small figure perched beside
him, with pitying eyes, and thought of her
dreary, colourless life.</p>
<p class="calibre7">"I'm reading a book now," she announced complacently.</p>
<p class="calibre7">"And what is it called?"</p>
<p class="calibre7">"The Mysteries of Paris."</p>
<p class="calibre7">"The <i class="calibre11">what</i>?"</p>
<p class="calibre7">"The Mysteries of Paris," raising her thin voice.
"I heard Mrs. Du Grand telling mother it was thrilling—and
so wicked. She rooted it out of the old
stock in the Library."</p>
<p class="calibre7">"It's not fit for you to read."</p>
<p class="calibre7">"Have <i class="calibre11">you</i> read it?" she asked sharply.</p>
<p class="calibre7">"No, and don't want to. Does your mother allow
you to read such stuff?"</p>
<p class="calibre7">"Mother does not know—she would not mind."</p>
<p class="calibre7">"I'm certain she would—it's a bad—I mean a
grown-up book, and not fit for you."</p>
<p class="calibre7">"I've only read as far as two chapters—and it's
so stupid."</p>
<p class="calibre7">"Then mind you don't read more, Angel, nor
any grown-up books, if you would like to please <i class="calibre11">me</i>.
Hullo, sit tight," he added quickly, as a white bullock
suddenly rose from beside a shrine, starting
Sally out of her wits. She made a violent spring

<span id="pgepubid00038" title="[Pg 37]"></span>

across the road—a spring that tested every buckle
in her harness—and nearly capsized the cart. Then
she broke away into a frantic gallop, with the trap
rocking at her heels.</p>
<p class="calibre7">"No fear, Angel; you hold on to me," said Gascoigne.</p>
<p class="calibre7">"But I'm not afraid," rejoined a bold, clear voice.
"I'm never afraid when I'm with you, Philip."</p>
<p class="calibre7">"It's all right," he said presently, as Sally's racing
pace slackened and she gradually came back to her
bit. "Sally is a coward; she thought she saw a
ghost."</p>
<p class="calibre7">"Yes; and it was only an old bullock," scoffed the
child. "But, cousin Phil, there <i class="calibre11">are</i> real ghosts, you
know."</p>
<p class="calibre7">"Where?"</p>
<p class="calibre7">"Oh," spreading out her hands, "everywhere, all
over the world—in the station—yes, and in your
bungalow."</p>
<p class="calibre7">"My poor, simple Angel! Who has been cramming
you with this rot?"</p>
<p class="calibre7">"The servants," she promptly replied; "and I've
heard other people talking. The cook's brother is
your bearer, and yet, he would not go into your
compound after dark if you gave him one hundred
rupees."</p>
<p class="calibre7">"Then he is a foolish man," pronounced Gascoigne;
"not that I am likely to offer him his price."</p>
<p class="calibre7">"They say," resumed the child, "where you keep
your boxes and polo sticks used to be the dining-room,
and that servants in queer old liveries can
still be seen there."</p>
<p class="calibre7"><span id="pgepubid00039" title="[Pg 38]"></span></p>
<p class="calibre7">"Then I wish to goodness they'd clean up my
saddles whilst they wait. And is that all?"</p>
<p class="calibre7">"No; an officer in uniform, a strange uniform not
worn now, comes running in with a drawn sword,
and chases a pretty lady from room to room. She
wears a white muslin dress, and black satin shoes.
He kills her in the front verandah—and her screams
are awful."</p>
<p class="calibre7">"Dear me, Angel, what a blood-curdling tragedy!
but you don't mean to say you believe it?"</p>
<p class="calibre7">"Oh, yes; Ibrahim says it is well known. There
is another—I heard Mrs. Jones telling it to mother,
and she said she knew it was true. Shall I go on?"</p>
<p class="calibre7">"Yes, if you like—it is quite an Indian night's
entertainment."</p>
<p class="calibre7">"Well," beginning in a formal little voice, "some
gentlemen were driving up from the station; they
were very late, and they saw a mess house all lit up,
and the compound packed with carriages and bullock
bandies, and they said, 'Why, it is a big ball,
and we never heard a word about it.' So they
stopped on the road and looked on. They could see
right into the room, and there were crowds of people
dancing—but the strange thing was, there was not
one face they knew."</p>
<p class="calibre7">"Well, I'm not surprised at that," exclaimed her
listener derisively.</p>
<p class="calibre7">"Please don't interrupt—they drove on after a
while——"</p>
<p class="calibre7">"They ought to have gone in to supper."</p>
<p class="calibre7">"<i class="calibre11">Philip!</i>" she expostulated. "Next morning they
asked about the great ball in the cavalry lines, and
people thought they were joking; there had not been

<span id="pgepubid00040" title="[Pg 39]"></span>

a dance for weeks, but these men were quite positive,
and they rode down to have a look at the house.
It had not been used for years and years, and was
crammed with rubbish and old broken furniture; the
compound was all grass and weeds, and there was
not a trace or mark of a carriage."</p>
<p class="calibre7">"And what did they make of that?" inquired Gascoigne.</p>
<p class="calibre7">"Oh, people just shook their heads, and said something
about an old story, and the mutiny, and that
a great many ladies were killed in that messhouse
one night—and the servants have heaps of tales."</p>
<p class="calibre7">"I don't want to hear their tales, and I wish you
would not listen to them," he said sharply.</p>
<p class="calibre7">"Why?" with a look of bewildered injury, "how
can I help it, when they are talking all round me?
The ayah's sister and her niece come in, and bring
a huka and sit on the floor of the nursery and gossip
when mother is out, and I can't sleep; they talk,
ever so much, all the station gup, oh, <i class="calibre11">such</i> stories.
Why are you so solemn, cousin Phil?" she asked
suddenly, gazing up at his face in the moonlight;
"why are you so grave; what are you thinking
about?"</p>
<p class="calibre7">"Then I will tell you, Angel; I am thinking about
<i class="calibre11">you</i>—it is full time you were at home."</p>
<p class="calibre7">"So I am at home. Here we are—the gate is
open. Oh, what a shy!" as Sally executed a deep
curtsey to a long black shadow.</p>
<p class="calibre7">"I mean England," giving Sally a flip; "would
you not like to go there?"</p>
<p class="calibre7">"No; for I don't want to leave mother. Anyway,
she cannot afford to send me to school. She owes

<span id="pgepubid00041" title="[Pg 40]"></span>

such a <i class="calibre11">lot</i> of money; there she is on the verandah
watching for us; and oh! I am so sorry this drive is
over—thank you a million thousand times."</p>
<p class="calibre7">"I am afraid we are rather late," he called out to
Mrs. Wilkinson, "but I've brought her back safe
and sound."</p>
<p class="calibre7">"Yes, thank goodness; it is after eight o'clock,
and I began to be nervous."</p>
<p class="calibre7">"I'm sorry I am behind time, but it is such a fine
moonlight night, and Angel has been telling me
stories."</p>
<p class="calibre7">"Oh, she's good enough at that!" sneered Colonel
Wilkinson, with terrible significance. "Now, Angel,
go off to your bed," he added peremptorily; "the
ayah has kept some cold rice pudding for you—mind
you eat it," and he waved her out of his sight.
Then, turning his attention to the child's charioteer,
and refusing to notice his wife's anxious signals, he
continued, "I say, Gascoigne, if you don't mind,
you'll be late for mess!"</p>
<p class="calibre7">It was all very well for Lena to suggest his staying
to share pot luck, but Lena was not the housekeeper,
or aware that the bill of fare consisted of a
little soup and some brain cutlets.</p>
<p class="calibre7">"The bugle went five minutes ago," he concluded.
Gascoigne promptly accepted the hint (not that he
craved for an invitation—were not Colonel Wilkinson's
dinners notorious?) and with a hasty good-bye
immediately drove away.</p>
<p class="calibre7">Surely, this must have been one of the happiest
days of Angel's existence; her mother was prepared
to find her in raptures, when she came to see her in
her cot that night. She was therefore astonished

<span id="pgepubid00042" title="[Pg 41]"></span>

to discover the child in tears, sobbing softly under
her breath—the cold rice-pudding untouched, and
spurned.</p>
<p class="calibre7">"Darling, what is the matter?" inquired Mrs.
Wilkinson anxiously. "Are you sick?"</p>
<p class="calibre7">"No," sniffed her daughter in a lachrymose key.</p>
<p class="calibre7">"But you have not eaten your supper," she expostulated;
"are you sure you are quite well, dearie?"</p>
<p class="calibre7">"I am—quite—well."</p>
<p class="calibre7">"Then," now stirred to indignation, "do you mean
to tell me, that after your delightful drive, and all
your beautiful presents, you greedy, insatiable child,
you are crying yourself to sleep?"</p>
<p class="calibre7">A heartrending sob was the sole reply to this question.</p>
<p class="calibre7">Mrs. Wilkinson's thoughts flew to her spouse; he
had been particularly impatient of Angel lately. She
bent over the cot, and whispered into the ear of the
little head buried in its pillow:</p>
<p class="calibre7">"Tell me, darling, what has happened? What is
the trouble—who——?"</p>
<p class="calibre7">And a muffled voice moaned like some wounded
animal:</p>
<p class="calibre7">"Phil—cousin Phil—he—he——" a burst of sobs
interrupted her.</p>
<p class="calibre7">"He what?" impatiently.</p>
<p class="calibre7">"Oh, mummy, he never said good-bye to me."</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0007.vue?744f5d88